import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import BranchInformation from "./branch"
import "../../Patient/list.scss"
import axios from "axios"
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage"

const BranchContainer = () => {

  const submitBranchInfo = (event, branchInfo) => {
    event.preventDefault();
   
    axios.post("https://arogyanxtdevapi.fundaclear.in/api/v1/Branch", branchInfo).then((res) =>{
      if(res?.status === 200){
        // navigate("/opd", { state: { addPatient: false } })
        successToast(res?.data?.message);
      }
    }).catch((err) =>{
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    })
  }
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <BranchInformation submitBranchInfo={submitBranchInfo} />
        </>
      </div>
    </div>
  )
}

export default BranchContainer